module.exports = __webpack_public_path__ + "static/img/logo-hy.04b984ab.png";